export const DISABLED_PHASE_VALUES = [
  "screening",
  "screening/undisclosed/undefined",
  "screening/undefined",
];
